
/**
 * Perform calculation based on the given operands and operator
 */
export const performCalculation = (
  firstOperand: number | null,
  operator: string | null,
  secondOperand: number
): number => {
  if (firstOperand === null || operator === null) {
    return secondOperand;
  }

  let result;

  switch (operator) {
    case '+':
      result = firstOperand + secondOperand;
      break;
    case '-':
      result = firstOperand - secondOperand;
      break;
    case '*':
      result = firstOperand * secondOperand;
      break;
    case '/':
      result = firstOperand / secondOperand;
      break;
    default:
      return secondOperand;
  }

  return result;
};
